import { SVGProps } from 'react';

const Apple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 6.528V3a1 1 0 0 1 1-1m-1 4.528A6 6 0 0 1 22 11a15 15 0 0 1-3.763 10 3 3 0 0 1-3.648.648 5.5 5.5 0 0 0-5.178 0A3 3 0 0 1 5.763 21 15.1 15.1 0 0 1 2 11a6 6 0 0 1 10-4.472"
    />
  </svg>
);
export default Apple;
